import { render, staticRenderFns } from "./TableGarbageAccessAnalytics.vue?vue&type=template&id=4f7d91ec"
import script from "./TableGarbageAccessAnalytics.vue?vue&type=script&lang=js"
export * from "./TableGarbageAccessAnalytics.vue?vue&type=script&lang=js"
import style0 from "./TableGarbageAccessAnalytics.vue?vue&type=style&index=0&id=4f7d91ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports